import { useState, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import DatePicker from "react-datepicker";
import Button from "react-bootstrap/Button";
import PraisePersonsList from "../Components/PraisePersonsList";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./PraisesLeaderboard.css";
import "react-datepicker/dist/react-datepicker.css";

function PraisesLeaderboard() {
  const [isLoading, setIsLoading] = useState(false);
  const [praises, setPraises] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [dueDate, setDueDate] = useState(new Date());

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  const handleSubmit = async () => {
    setIsLoading(true);
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/praises/leaderboard/people/${state.organization}`,
      data: {
        startDate: startDate,
        dueDate: dueDate,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });

    setPraises(response.data.leaderboard);
    setIsLoading(false);
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={12} className="values-header">
            <h2>{t("Reconocimientos.Leaderboard")}</h2>
          </Col>
        </Row>
        <Row>
          <Col className="inputContainer">
            <Row className="align-items-center">
              <Col lg={5}>
                <Form.Group className="mb-3">
                  <Form.Label>{t("Reconocimientos.FechaInicio")}</Form.Label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                  />
                </Form.Group>
              </Col>
              <Col lg={5}>
                <Form.Group className="mb-3">
                  <Form.Label>{t("Reconocimientos.FechaTermino")}</Form.Label>
                  <DatePicker
                    selected={dueDate}
                    onChange={(date) => setDueDate(date)}
                  />
                </Form.Group>
              </Col>
              <Col lg={2} className="center">
                <Button className="primary" onClick={handleSubmit}>
                  {t("Reconocimientos.Consultar")}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          {praises.length > 0 ? (
            <Col>
              <PraisePersonsList praises={praises} language={state.language} />
            </Col>
          ) : (
            <Col></Col>
          )}
        </Row>
      </Container>
    );
  }
}

export default PraisesLeaderboard;
